import _Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css'
import { NotificationButton } from '@src/interfaces/NotificationInterface'

type NotifyMessage = string | { text: string; timeout?: number; buttons?: NotificationButton[] }

export interface NotifyInterface {
  info: (msg: NotifyMessage, buttons?: NotificationButton[]) => void;
  success: (msg: NotifyMessage, buttons?: NotificationButton[]) => void;
  error: (msg: NotifyMessage, buttons?: NotificationButton[]) => void;
  critical: (msg: string) => void;
  log: (msg: string) => void;
}

function buildPayload (color: string, msg: NotifyMessage, buttons?: NotificationButton[]) {
  if (typeof msg === 'string') {
    return { color, text: msg, buttons: buttons || [] }
  }

  return {
    ...msg,
    color,
    buttons: msg.buttons || buttons || []
  }
}

const notify = {
  install (Vue: typeof _Vue, {store}) {
    Vue.prototype.$_notify = {
      info (msg, buttons) {
        store.commit('notification/showNotification', buildPayload('info', msg, buttons))
      },
      success (msg, buttons) {
        store.commit('notification/showNotification', buildPayload('success', msg, buttons))
      },
      error (msg, buttons) {
        store.commit('notification/showNotification', buildPayload('error', msg, buttons))
      },
      critical (msg) {
        console.error(msg)
      },
      log (msg) {
        console.error(msg)
      }
    } as NotifyInterface
  }
}

export default notify
